import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import styles from './SearchPageInfo.module.css';
import imgClone from './img/clone.jpg';

const SearchPageInfo = ({ people }) => (
    <>
        {people.length
            ? (
                <ul className={styles.list__conteiner}>
                    {people.map(({ id, name, img }) =>
                        <li className={styles.list__item} key={id}>
                            <Link to={`/people/${id}`}>
                                <img className={styles.person__photo} src={imgClone} alt={name} />
                                <p className={styles.person__name}>{name}</p>
                            </Link>
                        </li>
                    )}
                </ul>
            )
            : <h2 className={styles.person__coment}>No rezults</h2>
        
        } 
    </>
)

SearchPageInfo.propTypes = {
 people: PropTypes.array,
}

export default SearchPageInfo;
